<template>
  <vx-card
    id="loading-complementary-indicator"
    class="vs-con-loading__container w-full pointer"
    @click="handleClick"
  >
    <vs-row vs-type="flex">
      <vs-col
        vs-type="flex"
        vs-justify="center"
        vs-lg="1"
        vs-sm="1"
        vs-xs="1"
      >
        <feather-icon icon="CreditCardIcon" class="colorBoxC mr-2 mt-1" />
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="start"
        vs-lg="7"
        vs-sm="7"
        vs-xs="7"
        class="ml-4 mt-4"
      >
        {{ $t('complementary_payrolls') | capitalize }}
      </vs-col>
      <vs-col
        vs-type="flex"
        vs-justify="end"
        vs-lg="3"
        vs-sm="3"
        vs-xs="3"
        class="mt-3"
      >
        <span class="card-value">
          {{ this.ComplementaryCount }}/{{ this.ComplementaryTotal }}
        </span>
      </vs-col>
    </vs-row>
  </vx-card>
</template>

<script>
import dashboard from '@/http/requests/dashboard'
export default {
  props: {
    refresh: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      name: 'complementary-indicator',
      loading: false,
      ComplementaryCount: 0,
      ComplementaryTotal: 0,
    }
  },
  methods: {
    handleClick() {
      this.$emit('click')
    },
    getData() {
      this.loading = true
      dashboard
        .complementaryCard()
        .then((res) => {
          this.ComplementaryCount = res.data.data.complementary
          this.ComplementaryTotal = res.data.data.payrolls
          this.loading = false
        })
        .catch((err) => {
          console.log(err)
          this.loading = false
        })
    },
  },
  mounted() {
    this.getData()
    if (this.refresh === true) {
      var v = this
      setInterval(function () {
        v.getData()
      }, process.env.VUE_APP_CHART_RELOAD_TIME)
    }
  },
  watch: {
    loading(val) {
      if (val) {
        this.$vs.loading({
          container: `#loading-${this.name}`,
          scale: 0.45,
        })
      } else {
        this.$vs.loading.close(`#loading-${this.name} > .con-vs-loading`)
      }
    },
  },
}
</script>

<style>
.colorBoxH {
  padding: 5px;
  border-radius: 6px;
  color: rgb(112, 101, 236);
  background: rgba(112, 101, 236, 0.25);
}
.card-value {
  font-weight: bold;
  padding-top: 3%;
}
</style>